export class ResetProjectFormsList {
  public static readonly type = '[Project/Form/List] ResetProjectFormsList';
}
